import { ACTIONS } from '../Constants';

export default (state = {}, { type, payload }) => {
    switch (type) {
        case ACTIONS.GET_LOCAL_STORAGE:
        case ACTIONS.SET_LOCAL_STORAGE: {
            return {
                ...state,
                ...payload.localStorage
            };
        }
        default:
            return state;
    }
};
